import React from "react";
import { Card } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import "./LinkExpired.css";
import logoImage from "../../assets/images/dashboard-vector.png";

function LinkExpired() {
    return (
        <div className="forget-container">
            <Card bordered={false} className="forget-card">
                <div>
                    <img
                        src={logoImage}
                        alt="dashboard"
                        className="forget-dashboard-vector"
                    />
                </div>
                <div className="forget-contents">
                    <div className="title-container">Link Expired</div>
                    <div className="icon-container">
                        <ClockCircleOutlined className="clock-icon" />
                    </div>
                    <div className="description-container">
                        This link is invalid.
                        <br />
                        Please get new link to reset your password.
                    </div>
                </div>
            </Card>
        </div>
    );
}

export { LinkExpired };
